import React from "react";

const StakeIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.8333 1.66669L3.41118 10.5732C3.12051 10.922 2.97517 11.0964 2.97295 11.2437C2.97102 11.3718 3.02808 11.4936 3.12768 11.5741C3.24226 11.6667 3.46928 11.6667 3.92333 11.6667H9.99997L9.16663 18.3334L16.5888 9.42681C16.8794 9.078 17.0248 8.9036 17.027 8.7563C17.0289 8.62826 16.9719 8.50643 16.8723 8.42594C16.7577 8.33335 16.5307 8.33335 16.0766 8.33335H9.99997L10.8333 1.66669Z"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default StakeIcon;
